import React, { useEffect, useState } from "react"
import { Button, Input } from "antd"
import { Col, Modal, Row } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { submitResultDocument } from "../../../../reducers/manageStudies"

export default function AddUpdateResultDocument({ document, mode }) {
  // REDUX
  const dispatch = useDispatch()
  const selectedStudy = useSelector(state => state.manageStudies.selectedStudy)

  // STATE
  let [showModal, toggleModal] = useState(false)
  let [title, setTitle] = useState(document ? document.title : "")
  let [file, setFile] = useState({})

  useEffect(() => {
    setTitle(document ? document.title : "")
    setFile({})
  }, [document])

  const handleCancel = () => {
    toggleModal(false)
    setTitle(document ? document.title : "")
    setFile({})
  }

  const handleSubmit = () => {
    let newDocument = new FormData()

    if (document) {
      newDocument.append("url", document.url)
    } else {
      newDocument.append("url", `${process.env.REACT_APP_URL}result-documents/`)
    }
    newDocument.append("title", title)
    newDocument.append("document", file)
    newDocument.append("study", selectedStudy.url)
    selectedStudy.indications.forEach(indication => newDocument.append("indications", indication))
    newDocument.append("created_by", {})
    newDocument.append("modified_by", {})

    let method = "POST"
    if (mode === "update") {
      method = "PATCH"
    }
    toggleModal(false)
    dispatch(submitResultDocument(newDocument, method))
  }

  return (
    <div style={{ display: "inline-block" }}>
      <Button className="new-study-btn" onClick={ () => toggleModal(true) }>{ mode === "add" ? "Add Document" : "Update" }</Button>
      <Modal show={ showModal } onHide={ () => toggleModal(false) } size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            { mode === "add" ? "Add Document" : "Update" }
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col>
              <div><strong>Title</strong></div>
              <Input value={ title } placeholder="Enter a title..." onChange={ (e) => setTitle(e.target.value) }/>
            </Col>
            <Col>
              <div><strong>Document</strong></div>
              <input
                type="file"
                id="file-upload"
                onChange={ (e) => setFile(e.target.files[0]) }
              />
            </Col>
          </Row>
          <br/>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={ handleCancel }>Cancel</Button>
          <Button onClick={ handleSubmit }>Submit</Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}